import type { BeforeRequestHook } from "ky";

import { AUTH_TOKEN_KEY } from "../../../constants";
import { getMyToken } from "../../auth";

const ON_ERROR_REDIRECT_URL = "/oops";

/**
 * Uses the token defined in local storage, if present, as the
 * Authorization header.
 */
export const setAuthorizationHeader: BeforeRequestHook = async (request) => {
  let token = window.localStorage.getItem(AUTH_TOKEN_KEY);

  if (!token) {
    token = await getMyToken();

    if (token) {
      window.localStorage.setItem(AUTH_TOKEN_KEY, token);
    } else {
      if (window.location.pathname === ON_ERROR_REDIRECT_URL) {
        return;
      }

      window.location.assign(ON_ERROR_REDIRECT_URL);
      return;
    }
  }

  request.headers.set("Authorization", `Bearer ${token}`);
};
